// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"_3MTWp","loadingIcon":"t7ZNf"};